import { Outlet } from '@tanstack/react-router';
import AsyncPageContainer from '_/common/components/layout/AsyncPageContainer';
import MainSection from '_/common/components/layout/MainSection';
import useDocumentTitle from '_/hooks/useDocumentTitle';
import { useExtractionCells } from '_/hooks/useExtractionCells';
import React, { ReactElement } from 'react';

const title = 'ExtractionCells';

function ExtractionCellsContainer(): ReactElement {
  const { isLoading: loading } = useExtractionCells();

  useDocumentTitle(title);

  return (
    <MainSection>
      <AsyncPageContainer isLoading={loading}>
        <Outlet />
      </AsyncPageContainer>
    </MainSection>
  );
}

export default ExtractionCellsContainer;
